// src/pages/GuestLoginPage.jsx
import { Typography, Box, CircularProgress } from "@mui/material";
import { loginGuest } from "../../api/authService";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "../../context/SnackbarContext";
import { useEffect } from "react";

const GuestLoginPage = () => {
  const { t } = useTranslation("common");
  const { handleLogin } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const doLogin = async () => {
      const token = searchParams.get("token"); // ✅ get ?token=... from URL
      if (!token) {
        showSnackbar("Missing guest token in URL", "error");
        navigate("/login-fail"); // redirect somewhere safe
        return;
      }

      try {
        const res = await loginGuest(token);
        handleLogin(res.token); // update AuthContext
        showSnackbar("Signed in as guest", "success");
        navigate("/qr-page"); // or wherever guests should land
      } catch (err) {
        console.error(err);
        showSnackbar("Guest login failed", "error");
        navigate("/login-fail");
      }
    };

    doLogin();
  }, [searchParams, handleLogin, navigate, showSnackbar]);

  return (
    <>
      <Typography variant="h4" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
        Guest Login
      </Typography>
      <Typography variant="body1" sx={{ flexGrow: 1, marginBottom: "0rem" }}>
         {t('guests.messages.login_wait')}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "20vh" }}>
        <CircularProgress />
      </Box>
    </>
  );
};

export default GuestLoginPage;